import {computed} from 'vue';
import {AppLanguage} from '@/logged/common/composables';
import {I18nService} from '@malt/vue3-i18n';
import type {TourDefinition} from '../onboarding-existing-user.types';

export function useFreelancerTourDefinition() {
    const allTourDefinition = computed((): TourDefinition[] => [
        {
            navTabId: 'freelancer-inbox',
            illustrations: {
                [AppLanguage.FR]: 'https://dam.malt.com/navbar/onboarding/freelancer/FR/stay-in-touch-with-clients.png',
                [AppLanguage.EN]: 'https://dam.malt.com/navbar/onboarding/freelancer/EN/stay-in-touch-with-clients.png',
                [AppLanguage.ES]: 'https://dam.malt.com/navbar/onboarding/freelancer/ES/stay-in-touch-with-clients.png',
                [AppLanguage.DE]: 'https://dam.malt.com/navbar/onboarding/freelancer/DE/stay-in-touch-with-clients.png',
                [AppLanguage.NL]: 'https://dam.malt.com/navbar/onboarding/freelancer/NL/stay-in-touch-with-clients.png',
            },
            title: I18nService.msg('freelancer.navbar.tour.inbox.title'),
            body: I18nService.msg('freelancer.navbar.tour.inbox.body'),
        },
        {
            navTabId: 'freelancer-enhance-my-profile',
            illustrations: {
                [AppLanguage.FR]: 'https://dam.malt.com/navbar/onboarding/freelancer/FR/put-your-best-foot-forward.png',
                [AppLanguage.EN]: 'https://dam.malt.com/navbar/onboarding/freelancer/EN/put-your-best-foot-forward.png',
                [AppLanguage.ES]: 'https://dam.malt.com/navbar/onboarding/freelancer/ES/put-your-best-foot-forward.png',
                [AppLanguage.DE]: 'https://dam.malt.com/navbar/onboarding/freelancer/DE/put-your-best-foot-forward.png',
                [AppLanguage.NL]: 'https://dam.malt.com/navbar/onboarding/freelancer/NL/put-your-best-foot-forward.png',
            },
            title: I18nService.msg('freelancer.navbar.tour.profile.title'),
            body: I18nService.msg('freelancer.navbar.tour.profile.body'),
        },
        {
            navTabId: 'freelancer-company',
            illustrations: {
                [AppLanguage.FR]: 'https://dam.malt.com/navbar/onboarding/freelancer/FR/get-paid-fast.png',
                [AppLanguage.EN]: 'https://dam.malt.com/navbar/onboarding/freelancer/EN/get-paid-fast.png',
                [AppLanguage.ES]: 'https://dam.malt.com/navbar/onboarding/freelancer/ES/get-paid-fast.png',
                [AppLanguage.DE]: 'https://dam.malt.com/navbar/onboarding/freelancer/DE/get-paid-fast.png',
                [AppLanguage.NL]: 'https://dam.malt.com/navbar/onboarding/freelancer/NL/get-paid-fast.png',
            },
            title: I18nService.msg('freelancer.navbar.tour.business.title'),
            body: I18nService.msg('freelancer.navbar.tour.business.body'),
        },
        {
            navTabId: 'navbar-availability',
            illustrations: {
                [AppLanguage.FR]: 'https://dam.malt.com/navbar/onboarding/freelancer/FR/keep-your-profile-active.png',
                [AppLanguage.EN]: 'https://dam.malt.com/navbar/onboarding/freelancer/EN/keep-your-profile-active.png',
                [AppLanguage.ES]: 'https://dam.malt.com/navbar/onboarding/freelancer/ES/keep-your-profile-active.png',
                [AppLanguage.DE]: 'https://dam.malt.com/navbar/onboarding/freelancer/DE/keep-your-profile-active.png',
                [AppLanguage.NL]: 'https://dam.malt.com/navbar/onboarding/freelancer/NL/keep-your-profile-active.png',
            },
            title: I18nService.msg('freelancer.navbar.tour.availability.title'),
            body: I18nService.msg('freelancer.navbar.tour.availability.body'),
        },
    ]);

    return allTourDefinition;
}
